import React from "react";

const StartupIdeaModule = ({ payload }) => {
	return <>{payload[2].gray_text}</>;
};

export default StartupIdeaModule;
